module.exports = __webpack_public_path__ + "static/img/rank_242.f4688dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_242.png
// module id = Tjn0
// module chunks = 1